import type { ReceiptTemplate } from '../schema';

export const ultaTemplate: ReceiptTemplate = {
  id: 'ulta',
  name: 'Ulta Beauty Receipt',
  brand: 'ULTA BEAUTY',
  description: 'Ulta Beauty cosmetics store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ulta-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ulta.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ulta-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
          { id: 'assoc', label: 'Assoc:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ulta-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MAC LIPSTICK', quantity: '1', price: '21.00', sku: '847291034' },
          { id: '2', name: 'URBAN DECAY PALETTE', quantity: '1', price: '54.00', sku: '847291035' },
          { id: '3', name: 'MORPHE BRUSHES SET', quantity: '1', price: '25.00', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ulta-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '100.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '8.25', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '108.25', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ulta-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'ULTA CREDIT ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ulta-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ULTAMATE REWARDS MEMBER\nPOINTS EARNED: 200\n\nReturns within 60 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

